import { Menu } from "antd"
import { UserOutlined } from '@ant-design/icons';

const GlobalMenu = props => {

    const menu = [
        {
            key: 'user-mng',
            label: '用户管理',
            icon: <UserOutlined />
        }
    ]

    return <div>
        <Menu
            defaultSelectedKeys={['user-mng']}
            items={menu}
        />
    </div>
}

export default GlobalMenu
